module.exports = __webpack_public_path__ + "static/media/TO.bb794839.svg";